'use client';

import ErrorView from 'components/system/error-page/error-page';
// Error components must be Client Components
import { useParams } from 'next/navigation';

export default function Error() {
  const { locale } = useParams() as { locale: string };

  return <ErrorView locale={locale} />;
}
